<template>
  <div class="card">
    <div class="card_logo">
      <div class="card_logo_img">
        <img src="../../assets/images/logo.png" alt="">
      </div>
    </div>
    <div class="card_box" >
      <div class="card_content" >
        <p class="card_top"></p>
        <p class="card_tit">{{CardName.name}}</p>
        <div ref="CARDbOX" class="card_text">
          <div class="card_icon" v-if="CardName.type !=='certificate'">
            <img src="../../assets/images/card_top.png" alt="">
          </div>
          <div v-for="(item,index) in CardData" :key="index" class="card_list">
            <div v-if="item.required" >
              <div v-if="item.typeImg" class="card_list_tit">
                <div class="card_label">洗涤方法</div>
                <div class="card_value_img" v-show="showMode !==3">
                  <div v-for="(s,index) in AllIcon" :key="index" class="card_img">
                    <img :src="s.enumName" />
                  </div>
                </div>
                <div class="card_value_text" v-show="showMode !==2">
                  <div v-for="(s,index) in AllIcon" :key="index" class="card_img">
                    {{s.remark}}
                  </div>
                </div>
              </div>
              <div v-else-if="item.label==='号型'" class="card_list_tit">
                <div class="card_label">{{item.label}}</div>
                <div class="card_value">
                  {{item.firstValue}}
                </div>
              </div>
              <div v-else class="card_list_tit">
                <div class="card_label">{{item.label}}</div>
                <div class="card_value" v-html="item.value"></div>
              </div>
            </div>
            <div v-if="!item.required&&item.value" class="card_list_tit">
              <div v-if="item.label==='洗涤提醒'" >
<!--                <div class="card_label">{{item.label}}:</div>-->
                <div class="card_value" v-html="textareaWrap(item.value)"></div>
              </div>
              <div v-else>
                <div class="card_label">{{item.label}}</div>
                <div class="card_value" v-html="item.value"></div>
              </div>
            </div>

          </div>
          <div class="card_icon" v-if="CardName.type !=='certificate'">
            <img src="../../assets/images/card_bottom.png" alt="">
          </div>
        </div>

      </div>
      <div style="text-align: center;margin-top: 20px;display: flex;justify-content: center;">
<!--            <span @click="DownloadCertificate" class="down_btn" :loading="false">-->
<!--            下载{{CardName.name}}-->
<!--            </span>-->
        <el-button type="primary" :loading="btnLoading" @click="DownloadCertificate" class="down_btn">{{btnLoading?'加载中':`下载${CardName.name}`}}</el-button>
      </div>
      <div class="Make" v-if="MakeWash&&CardName.type==='certificate'" @click="JumpWashPage">
        <p class="Make_water_wash">
          继续制作水洗唛
        </p>
      </div>

    </div>
  </div>

</template>

<script>
const Base64 = require('js-base64').Base64
import { html2pdf } from '../../request/apis';
import { cardHtml } from '../../utils/card2pdf';

export default {
  name: "TicCertificateCard",
  props:{
    ParentDataFunction:{
      type:Function,
      default:null
    },
    CardData:{
      type:Array,
      default:()=>{}
    },
    CardName:{
      type:Object,
      default:()=>{}
    },
    JumpWash:{
      type:String,
      default:()=>''
    },
    apiUrl:{
      type:String,
      default:()=>''
    }
  },
  data(){
    return{
      AllIcon:[],
      btnLoading: false,
      MakeWash:false,
      SizeText:'',
      showMode:1
    }
  },
  created() {
  },
  watch:{
    CardData:{
      handler(newVal,oldVal){
        this.MakeWash=false
        let list=[]
        newVal.forEach(item=>{
          if(item.typeImg){
            this.showMode=item.showMode
            item.value.forEach(s=>{
              if(s.checkIcon){
                s.checkIcon.map(y=>{
                  list.push(y)
                })
              }
            })
          }
        })
        this.AllIcon=list
      },
      deep:true,
      immediate:true
    }
  },
  mounted() {
  },
  methods:{
    textareaWrap(content){
      return content ? content.replace(/\n/g, '<br/>') : content
    },
    JumpWashPage(){
      localStorage.setItem('WashSelectTypeSize',JSON.stringify(JSON.parse(localStorage.getItem('SelectTypeSize'))))
      this.$router.push({
        path:this.JumpWash,
        query:{
          fromPage:'label1'
        }
      })
    },
    DownloadCertificateData(){
      this.setBtnLoading(false)
      if(this.CardName.type==='certificate'){
        this.MakeWash=true
        let SelectTypeSize=JSON.parse(localStorage.getItem('SelectTypeSize'))
        this.dowHtml2pdf(SelectTypeSize,this.CardName.name)
        localStorage.removeItem('label1')
      }else{
        let SelectTypeSize=JSON.parse(localStorage.getItem('WashSelectTypeSize'))
        this.dowHtml2pdf(SelectTypeSize,this.CardName.name)
      }

    },
    dowHtml2pdf(SelectSize,name){
      html2pdf({
        fileContent: Base64.encode(cardHtml(SelectSize, this.CardData, name )),
      }, `${this.CardName.name}.pdf`, this.apiUrl, this, 'btnLoading')
    },
    setBtnLoading(val){
      this.btnLoading=val
    },
    DownloadCertificate(){
        this.setBtnLoading(true)
        this.ParentDataFunction()
    }
  }
}
</script>

<style scoped lang="scss">
p{
  margin: 0;
  padding: 0;
}
.card{
  .card_logo{
    width: 220px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    .card_logo_img{
      width: 103px;
      height: 45px;
    }
  }
  .card_box{
    width: 242px;
    .card_content{
      border: 1px solid #DCDCDC;
      font-size: 14px;
      min-height: 300px;
      box-shadow: -4px 5px 0px 0px rgba(0, 0, 0, 0.05);
      padding-bottom: 21px;
      background: #FFFFFF;
      .card_top{
        width: 240px;
        height: 14px;
        background: #FAFAFA;
      }
      .card_tit{
        font-size: 18px;
        font-weight: bold;
        color: #CA4300;
        margin: 11px 0 -10px 0;
        text-align: center;
      }
      .card_text{
        width:200px;
        margin-left: 22px;
        //max-height: 500px;
        //overflow: auto;
        margin-top: 19px;
        .card_icon{
          width: 180px;
          margin-bottom: 8px;
          img{
            width: 180px;
            height:14px;
            object-fit: cover;
          }
        }
        .card_list{
          margin-bottom: 12px;
          .card_list_tit{
            display: flex;
            flex-direction: column;
            word-wrap:break-word ;
            .card_label{
              font-size: 11px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #878787;
            }
            .card_value_img{
              display: flex;
              flex-wrap: wrap;
              .card_img{
                width: 25px;
                height: 25px;
                margin-right: 14px;
                img{
                  width: 25px;
                  height: 25px;
                  object-fit: cover;
                }
              }
            }
            .card_value_text{
              display: flex;
              flex-direction: column;
              font-size: 12px;
              margin-top: 10px;
            }
            .card_value{
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              word-wrap: break-word;
              word-break: break-all;
            }
          }
        }
      }

    }
    .down_btn{
      display: inline-block;
      width: 119px;
      height: 36px;
      background: #CA4300;
      border-radius: 3px;
      border: 1px solid #CA4300;
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
      text-align: center;
    }
    .Make{
      width: 242px;
      text-align: center;
      .Make_water_wash{
        width: 119px;
        height: 32px;
        border: 1px solid #CA4300;
        border-radius: 3px;
        font-size: 14px;
        font-weight: 400;
        color: #CA4300;
        text-align: center;
        margin-top: 20px;
        cursor: pointer;
        line-height: 32px;
        display: inline-block;
      }
    }


  }
}

</style>